import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { personLabel } from '../../components/ApprovalLevels.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface DeploymentRow {
  readonly deploymentId: string;
  readonly releaseVersion: string;
  readonly environmentCode: string | null;
  readonly environmentName: string | null;
  readonly status: string;
  readonly ownerName: string | null;
  readonly ownerCode: string | null;
}

export function M19DeploymentDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<DeploymentRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: DeploymentRow[] }>('/v1/platform/deployments', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.deployment.loading')}</p>;
  return (
    <main aria-label="deployment-dashboard">
      <h1>{t('m19.deployment.title')}</h1>
      <table aria-label="deployments-table">
        <thead><tr><th>{t('m19.deployment.colVersion')}</th><th>{t('m19.deployment.colEnvironment')}</th><th>{t('m19.deployment.colStatus')}</th><th>{t('m19.deployment.colOwner')}</th></tr></thead>
        <tbody>
          {rows.map((d) => (
            <tr key={d.deploymentId}>
              <td>{d.releaseVersion}</td>
              <td>{personLabel(d.environmentName, d.environmentCode) ?? '—'}</td>
              <td>{d.status}</td>
              <td>{personLabel(d.ownerName, d.ownerCode) ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
